interface Plataforma {
    rfc: string;
    nombre: string;
}

export const PLATAFORMAS: Plataforma[] = [
    { rfc: "AYM2205121Q2", nombre: "Yo Se Lo Reparo" },
    { rfc: "AIU120412G29", nombre: "Airbnb" },
    { rfc: "ASL020118JS5", nombre: "Amazon" },
    { rfc: "ASI030624312", nombre: "Amazon" },
    { rfc: "ABL021129CM2", nombre: "Auto Blitz" },
    { rfc: "BLA191211NF3", nombre: "Bauer, Lara & Asociados" },
    { rfc: "RIS120316SH9", nombre: "Bazaya Mexico" },
    { rfc: "BRA181218KP3", nombre: "Beat" },
    { rfc: "BME130802A75", nombre: "Boletia" },
    { rfc: "BBV9706235T7", nombre: "Booking" },
    { rfc: "BHM210616BK4", nombre: "Box Head" },
    { rfc: "CME1208017C4", nombre: "Cabify" },
    { rfc: "CRO170829FL1", nombre: "Canasta Rosa" },
    { rfc: "CMO1903134P1", nombre: "Cargamos" },
    { rfc: "PVC0712146V9", nombre: "Claroshop" },
    { rfc: "DGE1811204T1", nombre: "Delivering Geniality" },
    { rfc: "DTE160205976", nombre: "Derby Technologies" },
    { rfc: "DCM991109KR2", nombre: "Mercado Libre" },
    { rfc: "DMI1712045J9", nombre: "Didi" },
    { rfc: "DME170721UP2", nombre: "Dostavista" },
    { rfc: "EMG1611031N6", nombre: "Ebay" },
    { rfc: "ETE2003124M8", nombre: "Ecart Pay" },
    { rfc: "EIN060214DZ7", nombre: "Etsy" },
    { rfc: "FDE210122P81", nombre: "Future Of Delivery" },
    { rfc: "GME200512IE1", nombre: "Justo" },
    { rfc: "GPA2103231H4", nombre: "Gold Packaging" },
    { rfc: "HIN050121KJ5", nombre: "Homeaway" },
    { rfc: "HCT210819I95", nombre: "Home Care Technologies" },
    { rfc: "IQL150923HI3", nombre: "Incubadora Qp Labs" },
    { rfc: "IAD191101A10", nombre: "Izder" },
    { rfc: "LTM1911251H8", nombre: "Lalamove" },
    { rfc: "LEC190211D82", nombre: "Logistica Y Economia Colaborativa" },
    { rfc: "MER991006JMA", nombre: "Mercado Libre" },
    { rfc: "MSI2205133G9", nombre: "Moda Sinfonia" },
    { rfc: "MTM1908218CA", nombre: "Mensajeros Urbanos" },
    { rfc: "NME100630DS2", nombre: "Needish Mexico" },
    { rfc: "NCO030411DAA", nombre: "Nervio Comunicacion" },
    { rfc: "NCO1707187C3", nombre: "Nexoto Corporation" },
    { rfc: "NWM9709244W4", nombre: "Walmart" },
    { rfc: "NUV1206297Q6", nombre: "Nuvlar" },
    { rfc: "OKB2010192Y1", nombre: "Okboy" },
    { rfc: "NIM180312BT3", nombre: "Olist Mexico" },
    { rfc: "OPA160624HY1", nombre: "Cornershop" },
    { rfc: "RTP181221NE7", nombre: "Didi" },
    { rfc: "RTE2111046E9", nombre: "Rocketfy Team" },
    { rfc: "RNE220120LW8", nombre: "Rokaa News" },
    { rfc: "SME1808081K1", nombre: "Savorly De Mexico" },
    { rfc: "SOM101125UEA", nombre: "Sears" },
    { rfc: "ANE140618P37", nombre: "Amazon" },
    { rfc: "SIR110328IS0", nombre: "Servicios De Taxi En Linea" },
    { rfc: "SAC191112477", nombre: "Servicios Y Asesoria Cruz41" },
    { rfc: "AHM130822AW7", nombre: "Sih Servicios" },
    { rfc: "SME111110NY1", nombre: "Sindelantal" },
    { rfc: "SJT210310DC2", nombre: "Soy Juan Technologies" },
    { rfc: "STS2103054M4", nombre: "Spmx" },
    { rfc: "SMM2203105Y8", nombre: "Stockx Marketplace Mx" },
    { rfc: "TRA150604TW1", nombre: "Rappi" },
    { rfc: "TNE190426GT4", nombre: "Terapify" },
    { rfc: "TTE1510204D4", nombre: "Torus" },
    { rfc: "TMT210716HK2", nombre: "Tryp Mexico" },
    { rfc: "UBV121024TN8", nombre: "Uber" },
    { rfc: "UMB160114PN6", nombre: "Uber" },
    { rfc: "UPM191014S31", nombre: "Uber Eats" },
    { rfc: "UTL1005258F2", nombre: "Redtrack" },
    { rfc: "UGI0301223D6", nombre: "Upwork" },
    { rfc: "YOM190515JA8", nombre: "Yop Operaciones De Mexico" },
    { rfc: "ACS210820BV6", nombre: "Zubale" }
]; 